import React from 'react';
import { Link } from 'react-router-dom';

function ShopFooter() {
	return (
		<div className="shop__footer">
			<div className="shop__footer__links">
				<Link to="/shop/terms-of-service" className="site-link">Terms</Link>
				<span className="divider">|</span>
				<Link to="/shop/privacy-policy" className="site-link">Privacy</Link>
			</div>
			<div>Created by <a className="site-link" href="https://twitter.com/lslez" target="_blank">@lslez</a>.</div>
		</div>
	);
}

export default ShopFooter;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/ShopFooter.js